import App from './App.vue'
import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import api from './api'
import { extend, setInteractionMode } from 'vee-validate'
import { required, email, is, min, max, numeric } from 'vee-validate/dist/rules'
import marked from 'marked'
import helpers from 'marked/src/helpers'

Vue.prototype.$http = api

/**
 * Vee-Validate
 */
setInteractionMode('eager')
extend('required', {
  ...required,
  message: 'This field is required'
})
extend('min', {
  ...min,
  message: 'This field is too short'
})
extend('max', {
  ...max,
  message: 'This field is too long'
})
extend('email', {
  ...email,
  message: 'Please enter a valid email address'
})
extend('is', {
  ...is,
  message: 'This field is required'
})
extend('numeric', {
  ...numeric,
  message: 'Please enter numbers only'
})
extend('confirm', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

Vue.config.productionTip = false

/**
 * Markdown
 *
 */

// Overrides of Markdown default behavior to render links opening in new tabs
marked.Renderer.prototype.link = function (href, title, text) {
  href = helpers.cleanUrl(this.options.sanitize, this.options.baseUrl, href)
  if (href === null) {
    return text
  }
  let out = '<a target="_blank" href="' + helpers.escape(href) + '"'
  if (title) {
    out += ' title="' + title + '"'
  }
  out += '>' + text + '</a>'
  return out
}
Vue.filter('marked', marked)

/**
 * Modal close on click outside
 *
 * Taken from: https://stackoverflow.com/questions/36170425/detect-click-outside-element
 */
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
